"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateQuickBet = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const api_1 = require("./api");
const utils_1 = require("../../utils");
const errors_1 = require("../../utils/errors");
const slice_1 = require("./slice");
const useUpdateQuickBet = ({ onSuccess, onError, }) => {
    const [updateUserSettings, { isLoading }] = (0, api_1.useUpdateProfileSettings)();
    const { data: settings } = (0, api_1.useGetProfileSettings)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const updateQuickBetSum = (0, react_1.useCallback)(async (quickBetValue) => {
        const res = await updateUserSettings({
            ...settings,
            quickBetAmount: (0, utils_1.adjustAmountForBackend)(quickBetValue),
        });
        if ('error' in res) {
            const error = res.error;
            const errorInfo = (0, errors_1.getErrorOrUnknown)(error);
            if (onError) {
                onError(errorInfo);
            }
            return;
        }
        const { data } = res;
        dispatch(slice_1.settingsProviderActions.setSettingsDataSuccess({
            quickBetAmount: data.quickBetAmount,
        }));
        if (onSuccess) {
            onSuccess(data);
        }
    }, [updateUserSettings, settings, dispatch, onSuccess, onError]);
    return {
        isLoading,
        updateQuickBetSum,
    };
};
exports.useUpdateQuickBet = useUpdateQuickBet;
//# sourceMappingURL=useUpdateQuickBet.js.map